/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CommunityAnnouncement,
  CommunityAnnouncementCreationArgs,
  CommunityAnnouncementDeleteArgs,
  CommunityAnnouncementUpdateArgs,
  GetCommunityAnnouncementsParams,
  HTTPValidationError,
} from './platformapi.schemas';

import createCommunityAnnouncementMutator from '../custom-axios-instance';
import deleteCommunityAnnouncementMutator from '../custom-axios-instance';
import updateCommunityAnnouncementMutator from '../custom-axios-instance';
import getCommunityAnnouncementsMutator from '../custom-axios-instance';
import countCommunityAnnouncementsMutator from '../custom-axios-instance';

/**
 * Creates a new community announcement
 * @summary Create Community Announcement
 */
export const createCommunityAnnouncement = (
  communityAnnouncementCreationArgs: CommunityAnnouncementCreationArgs,
  signal?: AbortSignal,
) => {
  return createCommunityAnnouncementMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-announcements/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityAnnouncementCreationArgs,
    signal,
  });
};

export const getCreateCommunityAnnouncementMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementCreationArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementCreationArgs },
  TContext
> => {
  const mutationKey = ['createCommunityAnnouncement'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunityAnnouncement>>,
    { data: CommunityAnnouncementCreationArgs }
  > = (props) => {
    const { data } = props ?? {};

    return createCommunityAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommunityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunityAnnouncement>>
>;
export type CreateCommunityAnnouncementMutationBody = CommunityAnnouncementCreationArgs;
export type CreateCommunityAnnouncementMutationError = void | HTTPValidationError;

/**
 * @summary Create Community Announcement
 */
export const useCreateCommunityAnnouncement = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementCreationArgs },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementCreationArgs },
  TContext
> => {
  const mutationOptions = getCreateCommunityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Deletes a community announcement
 * @summary Delete Community Announcement
 */
export const deleteCommunityAnnouncement = (
  communityAnnouncementDeleteArgs: CommunityAnnouncementDeleteArgs,
  signal?: AbortSignal,
) => {
  return deleteCommunityAnnouncementMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-announcements/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityAnnouncementDeleteArgs,
    signal,
  });
};

export const getDeleteCommunityAnnouncementMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteCommunityAnnouncement'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunityAnnouncement>>,
    { data: CommunityAnnouncementDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteCommunityAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommunityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunityAnnouncement>>
>;
export type DeleteCommunityAnnouncementMutationBody = CommunityAnnouncementDeleteArgs;
export type DeleteCommunityAnnouncementMutationError = void | HTTPValidationError;

/**
 * @summary Delete Community Announcement
 */
export const useDeleteCommunityAnnouncement = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementDeleteArgs },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteCommunityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Updates an existing community announcement
 * @summary Update Community Announcement
 */
export const updateCommunityAnnouncement = (
  communityAnnouncementUpdateArgs: CommunityAnnouncementUpdateArgs,
  signal?: AbortSignal,
) => {
  return updateCommunityAnnouncementMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/community-announcements/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: communityAnnouncementUpdateArgs,
    signal,
  });
};

export const getUpdateCommunityAnnouncementMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateCommunityAnnouncement'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunityAnnouncement>>,
    { data: CommunityAnnouncementUpdateArgs }
  > = (props) => {
    const { data } = props ?? {};

    return updateCommunityAnnouncement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunityAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunityAnnouncement>>
>;
export type UpdateCommunityAnnouncementMutationBody = CommunityAnnouncementUpdateArgs;
export type UpdateCommunityAnnouncementMutationError = void | HTTPValidationError;

/**
 * @summary Update Community Announcement
 */
export const useUpdateCommunityAnnouncement = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunityAnnouncement>>,
    TError,
    { data: CommunityAnnouncementUpdateArgs },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunityAnnouncement>>,
  TError,
  { data: CommunityAnnouncementUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateCommunityAnnouncementMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Retrieves currently available community announcements
 * @summary Get Community Announcements
 */
export const getCommunityAnnouncements = (
  params: GetCommunityAnnouncementsParams,
  signal?: AbortSignal,
) => {
  return getCommunityAnnouncementsMutator<CommunityAnnouncement[]>({
    url: `${import.meta.env['VITE_API_HOST']}/community-announcements/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCommunityAnnouncementsQueryKey = (params: GetCommunityAnnouncementsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/community-announcements/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCommunityAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityAnnouncementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityAnnouncements>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommunityAnnouncementsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunityAnnouncements>>> = ({
    signal,
  }) => getCommunityAnnouncements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunityAnnouncements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCommunityAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunityAnnouncements>>
>;
export type GetCommunityAnnouncementsQueryError = void | HTTPValidationError;

export function useGetCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof getCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityAnnouncementsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityAnnouncements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getCommunityAnnouncements>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof getCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityAnnouncementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityAnnouncements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getCommunityAnnouncements>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof getCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityAnnouncementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityAnnouncements>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Community Announcements
 */

export function useGetCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof getCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(
  params: GetCommunityAnnouncementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityAnnouncements>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCommunityAnnouncementsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves currently available community announcements
 * @summary Count Community Announcements
 */
export const countCommunityAnnouncements = (signal?: AbortSignal) => {
  return countCommunityAnnouncementsMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/community-announcements/count`,
    method: 'GET',
    signal,
  });
};

export const getCountCommunityAnnouncementsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/community-announcements/count`] as const;
};

export const getCountCommunityAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof countCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countCommunityAnnouncements>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountCommunityAnnouncementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countCommunityAnnouncements>>> = ({
    signal,
  }) => countCommunityAnnouncements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countCommunityAnnouncements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CountCommunityAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof countCommunityAnnouncements>>
>;
export type CountCommunityAnnouncementsQueryError = void | HTTPValidationError;

export function useCountCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof countCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countCommunityAnnouncements>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof countCommunityAnnouncements>>,
        TError,
        Awaited<ReturnType<typeof countCommunityAnnouncements>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCountCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof countCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countCommunityAnnouncements>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof countCommunityAnnouncements>>,
        TError,
        Awaited<ReturnType<typeof countCommunityAnnouncements>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCountCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof countCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countCommunityAnnouncements>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Count Community Announcements
 */

export function useCountCommunityAnnouncements<
  TData = Awaited<ReturnType<typeof countCommunityAnnouncements>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countCommunityAnnouncements>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCountCommunityAnnouncementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
